(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[403,37,952],{

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 11640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addMonths; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/***/ }),

/***/ 21593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addYears; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11640);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * 12);
}

/***/ }),

/***/ 3151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isSameDay; }
/* harmony export */ });
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69119);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRightStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),

/***/ 60037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CloseButton": function() { return /* binding */ CloseButton; },
/* harmony export */   "CloseModal": function() { return /* binding */ CloseModal; },
/* harmony export */   "Content": function() { return /* binding */ Content; },
/* harmony export */   "ModalFooter": function() { return /* binding */ ModalFooter; },
/* harmony export */   "StyledModal": function() { return /* binding */ StyledModal; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71383);
/* harmony import */ var atomic_layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19010);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68219);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96502);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42997);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;







var StyledModal = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .ZP.div(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 50;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.colors.background, "cc");
});
var Content = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  z-index: 51;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: ", ";\n  padding: 0 1rem;\n  width: 90%;\n  max-height: 40rem;\n  overflow-y: auto;\n  overflow-x: hidden;\n  border-radius: 5px;\n  padding-top: 0.1rem;\n  @media screen and (min-width: ", ") {\n    width: 40rem;\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.colors.background);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.sm.minWidth;
});
var CloseModal = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .ZP.div(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  position: sticky;\n  top: 0;\n  z-index: 55;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 5px 5px 0 0;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  background: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.tableHead;
});
var CloseButton = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button */ .ZP.button(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  border: none;\n  cursor: pointer;\n  color: ", ";\n  font-size: inherit;\n  font-weight: bold;\n  padding: 1rem;\n  background: ", ";\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  border-radius: 5px;\n\n  &:hover {\n    background: ", ";\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.textInverse;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
}, function (_ref7) {
  var theme = _ref7.theme;
  return (0,polished__WEBPACK_IMPORTED_MODULE_5__/* .lighten */ .$n)(0.1, theme.colors.primary);
});
var ModalFooter = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .ZP.div(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  position: sticky;\n  bottom: 0;\n  z-index: 54;\n  width: 100%;\n  padding: 1rem;\n  border-radius: 0 0 5px 5px;\n  background: transparent;\n"])));

var Modal = function Modal(_ref8) {
  var title = _ref8.title,
      onClose = _ref8.onClose,
      children = _ref8.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledModal, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Content, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(CloseModal, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_1__.H4, {
          children: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CloseButton, {
          onClick: onClose,
          children: "Close"
        })]
      }), children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(ModalFooter, {})]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Modal);

/***/ }),

/***/ 68219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ER": function() { return /* binding */ Summary; },
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H3": function() { return /* binding */ H3; },
/* harmony export */   "H4": function() { return /* binding */ H4; },
/* harmony export */   "HU": function() { return /* binding */ FooterText; },
/* harmony export */   "O": function() { return /* binding */ CardParagraph; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* unused harmony export FooterLink */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71383);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42997);


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;


var H1 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h1 */ .ZP.h1(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: 1.5rem;\n  text-align: ", ";\n  font-size: ", ";\n  @media screen and (max-width: ", ") {\n    font-size: ", ";\n  }\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.headingFontFamily;
}, function (_ref2) {
  var $textAlign = _ref2.$textAlign;
  return $textAlign ? $textAlign : 'initial';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.desktopFontSize.title;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.mobileFontSize.title;
}, function (_ref6) {
  var theme = _ref6.theme,
      $brand = _ref6.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
});
var H2 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2 */ .ZP.h2(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: ", ";\n  font-size: ", ";\n  position: ", ";\n  left: ", ";\n  color: ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.headingFontFamily;
}, function (_ref8) {
  var $marginBottom = _ref8.$marginBottom;
  return $marginBottom || '1.5rem';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.fontSizes[2];
}, function (_ref10) {
  var $sticky = _ref10.$sticky;
  return $sticky ? 'sticky' : 'initial';
}, function (_ref11) {
  var $sticky = _ref11.$sticky;
  return $sticky ? 0 : 'initial';
}, function (_ref12) {
  var theme = _ref12.theme,
      $brand = _ref12.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
});
var H3 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3 */ .ZP.h3(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: initial;\n  color: ", ";\n  font-size: ", ";\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.headingFontFamily;
}, function (_ref14) {
  var $color = _ref14.$color;
  return $color ? $color : 'inherit';
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.fontSizes[4];
});
var H4 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h4 */ .ZP.h4(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: ", ";\n  margin: initial;\n  margin-bottom: initial;\n  color: ", ";\n  font-size: ", ";\n\n  display: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  min-height: ", ";\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.typography.headingFontFamily;
}, function (_ref17) {
  var $padding = _ref17.$padding;
  return $padding ? $padding : 'initial';
}, function (_ref18) {
  var theme = _ref18.theme,
      $brand = _ref18.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.typography.fontSizes[5];
}, function (_ref20) {
  var $ellipsis = _ref20.$ellipsis;
  return $ellipsis && '-webkit-box';
}, function (_ref21) {
  var $ellipsis = _ref21.$ellipsis;
  return $ellipsis && 2;
}, function (_ref22) {
  var $ellipsis = _ref22.$ellipsis;
  return $ellipsis && 'vertical';
}, function (_ref23) {
  var $ellipsis = _ref23.$ellipsis;
  return $ellipsis && 'hidden';
}, function (_ref24) {
  var $ellipsis = _ref24.$ellipsis;
  return $ellipsis && 'ellipsis';
}, function (_ref25) {
  var $ellipsis = _ref25.$ellipsis;
  return $ellipsis && '3.4rem';
});
var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  text-align: ", ";\n  padding: ", ";\n  margin: initial;\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: calc(\n    ", " * 2\n  );\n  color: ", ";\n\n  display: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  min-height: ", ";\n"])), function (_ref26) {
  var theme = _ref26.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref27) {
  var $textAlign = _ref27.$textAlign;
  return $textAlign ? $textAlign : 'left';
}, function (_ref28) {
  var $padding = _ref28.$padding;
  return $padding ? $padding : '2rem 0';
}, function (_ref29) {
  var $fontWeight = _ref29.$fontWeight;
  return $fontWeight ? $fontWeight : 'initial';
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.typography.fontSizes[5];
}, function (_ref31) {
  var theme = _ref31.theme,
      $lineHeight = _ref31.$lineHeight;
  return $lineHeight ? $lineHeight : theme.typography.fontSizes[5];
}, function (_ref32) {
  var theme = _ref32.theme,
      $brand = _ref32.$brand,
      $color = _ref32.$color;
  return $brand ? theme.colors.primary : theme.colors[$color || 'text'];
}, function (_ref33) {
  var $ellipsis = _ref33.$ellipsis;
  return $ellipsis && '-webkit-box';
}, function (_ref34) {
  var $ellipsis = _ref34.$ellipsis;
  return $ellipsis && 4;
}, function (_ref35) {
  var $ellipsis = _ref35.$ellipsis;
  return $ellipsis && 'vertical';
}, function (_ref36) {
  var $ellipsis = _ref36.$ellipsis;
  return $ellipsis && 'hidden';
}, function (_ref37) {
  var $ellipsis = _ref37.$ellipsis;
  return $ellipsis && 'ellipsis';
}, function (_ref38) {
  var $ellipsis = _ref38.$ellipsis;
  return $ellipsis && '9.7rem';
});
var Summary = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  text-align: ", ";\n  max-width: 100vw;\n  overflow-wrap: break-word;\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n  }\n"])), function (_ref39) {
  var $textAlign = _ref39.$textAlign;
  return $textAlign ? $textAlign : 'center';
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.typography.fontSizes[3];
});
var CardParagraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(_templateObject7 || (_templateObject7 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  font-size: ", ";\n  line-height: calc(", " * 1.25);\n  color: ", ";\n"])), function (_ref42) {
  var theme = _ref42.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.typography.fontSizes[5];
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.typography.fontSizes[5];
}, function (_ref45) {
  var $color = _ref45.$color,
      theme = _ref45.theme;
  return $color ? $color : theme.colors.text;
});
var FooterLink = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a */ .ZP.a(_templateObject8 || (_templateObject8 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (_ref46) {
  var theme = _ref46.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref47) {
  var theme = _ref47.theme,
      $brand = _ref47.$brand;
  return $brand ? theme.colors.linkColours.alt : theme.colors.text;
}, function (_ref48) {
  var theme = _ref48.theme,
      $brand = _ref48.$brand;
  return $brand ? theme.colors.linkColours.altHover : theme.colors.text;
});
var FooterText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject9 || (_templateObject9 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  text-align: center;\n  max-width: 800px;\n  line-height: 1.2;\n  a {\n    font-family: ", ";\n    color: ", ";\n  }\n"])), function (_ref49) {
  var theme = _ref49.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref50) {
  var theme = _ref50.theme;
  return theme.colors.primary;
});

/***/ }),

/***/ 19403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ inputs; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./components/atoms/form/index.js + 2 modules
var atoms_form = __webpack_require__(6427);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./utils/currency.js
var utils_currency = __webpack_require__(92442);
// EXTERNAL MODULE: ./node_modules/atomic-layout/lib/esm/index.js
var esm = __webpack_require__(19010);
// EXTERNAL MODULE: ./node_modules/duration-fns/dist/index.js
var dist = __webpack_require__(38174);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/form/select.js
var form_select = __webpack_require__(49654);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addYears/index.js
var addYears = __webpack_require__(21593);
// EXTERNAL MODULE: ./utils/date.js
var date = __webpack_require__(90144);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(42997);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/Checkbox.js


var _templateObject, _templateObject2;





var StyledCheckboxContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  border: 2px solid ", ";\n  ", ";\n  padding: 1px;\n  width: 15px;\n  height: 15px;\n  position: relative;\n  margin: 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.text;
}, function (_ref2) {
  var focused = _ref2.focused;
  return focused ? 'outline: 1px solid' : '';
});
var HiddenInput = styled_components_browser_esm/* default.input */.ZP.input(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  opacity: 0;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n"])));
function Checkbox(_ref3) {
  var checked = _ref3.checked,
      onChange = _ref3.onChange,
      _id = _ref3._id;

  var _useState = (0,react.useState)(false),
      focused = _useState[0],
      setFocused = _useState[1];

  var onFocus = function onFocus() {
    setFocused(true);
  };

  var onBlur = function onBlur() {
    setFocused(false);
  };

  var handleClick = function handleClick() {
    setFocused(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCheckboxContainer, {
    onClick: handleClick,
    focused: focused,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HiddenInput, {
      onFocus: onFocus,
      onBlur: onBlur,
      id: _id,
      checked: checked,
      onChange: onChange,
      type: "checkbox"
    }), checked && /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      width: "12",
      height: "12",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        width: "48",
        height: "48",
        fill: "white",
        "fill-opacity": "0.01"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M43 11L16.875 37L5 25.1818",
        stroke: "currentColor",
        "stroke-width": "10",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./components/atoms/CustomPrice.js


var CustomPrice_templateObject;


var StyledCustomPrices = styled_components_browser_esm/* default.div */.ZP.div(CustomPrice_templateObject || (CustomPrice_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: flex;\n    gap: 0.6rem;\n    align-items: center;\n    font-size: 1.1rem;\n"])));
;// CONCATENATED MODULE: ./components/content/calculator/inputs/goalDate.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var CustomDateCheckbox = function CustomDateCheckbox(_ref) {
  var inputsData = _ref.inputsData;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
    name: "customDate",
    initialValue: false,
    type: "checkbox",
    children: function children(_ref2) {
      var input = _ref2.input;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCustomPrices, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "custom-date-checkbox",
            children: inputsData.setCustomDate
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox, {
            _id: "custom-date-checkbox",
            onChange: input.onChange,
            checked: input.checked
          })]
        })
      });
    }
  });
};

function GoalDateField(_ref3) {
  var _goalDateSelectOption;

  var inputsData = _ref3.inputsData;
  var helpTexts = inputsData.helpTexts,
      customGoalDateOptionLabel = inputsData.customGoalDateOptionLabel,
      _inputsData$goalDateS = inputsData.goalDateSelectOptions,
      goalDateSelectOptions = _inputsData$goalDateS === void 0 ? [] : _inputsData$goalDateS;
  var form = (0,react_final_form_es.useForm)();

  var _useFormState = (0,react_final_form_es.useFormState)(),
      values = _useFormState.values;

  var goalDateSelect = values.goalDateSelect,
      _values$useStackingAm = values.useStackingAmount,
      useStackingAmount = _values$useStackingAm === void 0 ? true : _values$useStackingAm,
      customDate = values.customDate;
  (0,react.useEffect)(function () {
    if (goalDateSelect !== 'CUSTOM') {
      var period = dist.parse(goalDateSelect);
      var newDate = dist.apply(new Date(), period);
      form.change('goalDate', newDate);
    }
  }, [goalDateSelect]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!customDate && /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
      name: "goalDateSelect",
      initialValue: (goalDateSelectOptions === null || goalDateSelectOptions === void 0 ? void 0 : (_goalDateSelectOption = goalDateSelectOptions.find(function (opt) {
        return opt["default"];
      })) === null || _goalDateSelectOption === void 0 ? void 0 : _goalDateSelectOption.durationISO) || 'CUSTOM',
      children: function children(_ref4) {
        var input = _ref4.input,
            meta = _ref4.meta;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.StyledField, {
          id: "goalDateSelect",
          label: useStackingAmount ? inputsData.goalDateLabelPredictByInvestmentAmount : inputsData.goalDateLabelPredictByGoal,
          error: meta.touched && meta.error,
          help: useStackingAmount ? helpTexts.goalDateSelectPredictByInvestmentAmount : helpTexts.goalDateSelect,
          upperRightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomDateCheckbox, {
            inputsData: inputsData
          }),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(form_select/* Select */.P, _objectSpread(_objectSpread({}, input), {}, {
            id: "goalDateSelect",
            children: (goalDateSelectOptions || []).map(function (_ref5, idx) {
              var durationISO = _ref5.durationISO,
                  label = _ref5.label;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                value: durationISO,
                children: label
              }, idx);
            })
          }))
        });
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
      name: "goalDate",
      children: function children(_ref6) {
        var input = _ref6.input,
            meta = _ref6.meta;
        return customDate ? /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.StyledField, {
          id: "goalDate",
          label: useStackingAmount ? inputsData.customGoalDatePickerLabelPredictByInvestment : inputsData.customGoalDatePickerLabelPredictByGoal,
          error: meta.touched && meta.error,
          help: useStackingAmount ? helpTexts.goalDatePredictByInvestmentAmount : helpTexts.goalDate,
          upperRightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomDateCheckbox, {
            inputsData: inputsData
          }),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.DatePicker, _objectSpread(_objectSpread({
            id: "goalDate"
          }, input), {}, {
            minDate: (0,date/* dateOnly */.hp)((0,addDays/* default */.Z)(new Date(), 1)),
            maxDate: (0,addYears/* default */.Z)((0,date/* dateOnly */.hp)(new Date()), 50),
            style: {
              border: 'none'
            }
          }))
        }) : null;
      }
    })]
  });
}
// EXTERNAL MODULE: ./components/content/calculator/inputs/goal.js
var goal = __webpack_require__(51731);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
;// CONCATENATED MODULE: ./components/atoms/form/formButton.js



var FormButton = styled_components_browser_esm/* default.button */.ZP.button(function (_ref) {
  var $isSecondary = _ref.$isSecondary,
      theme = _ref.theme;
  return (0,defineProperty/* default */.Z)({
    border: 'none',
    cursor: 'pointer',
    flex: 1,
    flexShrink: 0,
    color: $isSecondary ? theme.colors.text : theme.colors.textInverse,
    fontSize: 'inherit',
    fontWeight: 'bold',
    padding: '1rem 2rem',
    background: $isSecondary ? theme.colors.secondary : theme.colors.primary,
    backdropFilter: 'blur(4px)',
    '-webkit-backdrop-filter': 'blur(4px)',
    borderRadius: '5px',
    minHeight: '40px'
  }, '&:hover', {
    background: $isSecondary ? (0,polished_esm/* lighten */.$n)(0.1, theme.colors.secondary) : (0,polished_esm/* lighten */.$n)(0.1, theme.colors.primary)
  });
});
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(3151);
// EXTERNAL MODULE: ./utils/useCryptoValue.js
var useCryptoValue = __webpack_require__(19319);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./utils/btcApi/fetchHistoricBtcPrice.js




function fetchHistoricBtcPrice(_x) {
  return _fetchHistoricBtcPrice.apply(this, arguments);
}

function _fetchHistoricBtcPrice() {
  _fetchHistoricBtcPrice = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var date, res;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            date = _ref.date;
            _context.next = 3;
            return axios_default().get("/api/satsgoal-historic?date=".concat(date));

          case 3:
            res = _context.sent;
            return _context.abrupt("return", res.data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchHistoricBtcPrice.apply(this, arguments);
}

function fetchMultipleHistoricBtcPrice(_x2) {
  return _fetchMultipleHistoricBtcPrice.apply(this, arguments);
}

function _fetchMultipleHistoricBtcPrice() {
  _fetchMultipleHistoricBtcPrice = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref2) {
    var dates, promises, res;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            dates = _ref2.dates;
            promises = dates.map(function (_ref3) {
              var year = _ref3.year,
                  month = _ref3.month,
                  day = _ref3.day;
              return fetchHistoricBtcPrice({
                date: (0,date/* formatDateForHistoricApi */.p$)({
                  year: year,
                  month: month,
                  day: day
                })
              });
            });
            _context2.next = 4;
            return Promise.all(promises);

          case 4:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchMultipleHistoricBtcPrice.apply(this, arguments);
}
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./components/atoms/Modal.js
var Modal = __webpack_require__(60037);
// EXTERNAL MODULE: ./components/atoms/Text.js
var Text = __webpack_require__(68219);
;// CONCATENATED MODULE: ./components/atoms/List.js


var List_templateObject, List_templateObject2;


var OL = styled_components_browser_esm/* default.ol */.ZP.ol(List_templateObject || (List_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var LI = styled_components_browser_esm/* default.li */.ZP.li(List_templateObject2 || (List_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([""])));
// EXTERNAL MODULE: ./components/atoms/Buttons.js
var Buttons = __webpack_require__(87314);
;// CONCATENATED MODULE: ./components/custom-pricing-modal/index.js



var custom_pricing_modal_templateObject;






var StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal.StyledModal)(custom_pricing_modal_templateObject || (custom_pricing_modal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 999;\n  background: rgba(102, 102, 102, 0.5);\n  overflow: auto;\n"])));
var StyledContent = (0,styled_components_browser_esm/* default */.ZP)(Modal.Content)(function (_ref) {
  var theme = _ref.theme,
      $width = _ref.$width;
  return (0,defineProperty/* default */.Z)({
    maxHeight: '80%',
    padding: '2.2rem 2rem 2rem 2rem',
    background: theme.colors.modal2Background,
    overflow: 'hidden',
    position: 'relative',
    borderRadius: '10px',
    width: '90%'
  }, "@media screen and (min-width: ".concat(theme.breakpoints.md.minWidth, ")"), {
    width: $width || 'auto',
    maxWidth: '90%'
  });
});
var StyledHeader = styled_components_browser_esm/* default.div */.ZP.div(function (_ref3) {
  var $col = _ref3.$col;
  return {
    display: 'flex',
    flexDirection: $col ? 'column' : 'row',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '1.4rem',
    alignItems: 'center',
    gap: $col ? '1rem' : 'initial'
  };
});
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Text.H4)(function (_ref4) {
  var theme = _ref4.theme;
  return (0,defineProperty/* default */.Z)({
    textAlign: 'left',
    fontSize: '2.1rem',
    width: '100%',
    color: theme.isDark ? '#fff' : 'inherit',
    letterSpacing: '0.1rem'
  }, '@media screen and (max-width: 700px)', {
    fontSize: '1.5rem',
    marginRight: '0.1rem'
  });
});
var StyledSubTitle = (0,styled_components_browser_esm/* default */.ZP)(Text.H4)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    textAlign: 'left',
    fontSize: '1.4rem',
    width: '100%',
    color: theme.colors.primary,
    fontWeight: 600,
    letterSpacing: '0.1rem'
  };
});
// EXTERNAL MODULE: ./components/content/calculator/inputs/predictionInputs.js + 3 modules
var predictionInputs = __webpack_require__(61952);
;// CONCATENATED MODULE: ./utils/constants.js
var BITCOIN_FOUNDATION_DATE = new Date("07-01-2009");
var BITCOIN_API_BEGIN_DATE = new Date("07-17-2010");
;// CONCATENATED MODULE: ./components/custom-pricing-modal/custom-pricing-modal.js



var custom_pricing_modal_custom_pricing_modal_templateObject, custom_pricing_modal_templateObject2, _templateObject3, _templateObject4, _templateObject5;

function custom_pricing_modal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function custom_pricing_modal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? custom_pricing_modal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : custom_pricing_modal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var custom_pricing_modal_StyledCheckboxContainer = styled_components_browser_esm/* default.div */.ZP.div(custom_pricing_modal_custom_pricing_modal_templateObject || (custom_pricing_modal_custom_pricing_modal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1.3rem;\n"])));
var StyledCustomDateContainer = styled_components_browser_esm/* default.div */.ZP.div(custom_pricing_modal_templateObject2 || (custom_pricing_modal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 1rem;\n"])));
var StyledCustomDateInputContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 0.5rem;\n  flex-direction: column;\n"])));
var StyledFormContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  display: flex;\n  align-items: start;\n  flex-direction: column;\n"])));
var StyledPercentageIncrease = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 1rem;\n"])));
function CustomPricingModal(_ref) {
  var _document;

  var inputsData = _ref.inputsData,
      cagrCustomDate = _ref.cagrCustomDate,
      setCagrCustomDate = _ref.setCagrCustomDate,
      cagrCustomDatePercentage = _ref.cagrCustomDatePercentage,
      useStackingAmount = _ref.useStackingAmount,
      open = _ref.open,
      onClose = _ref.onClose,
      increaseValueByPercentage = _ref.increaseValueByPercentage,
      increaseValueByPercentageOnChange = _ref.increaseValueByPercentageOnChange,
      useCagrCustomDate = _ref.useCagrCustomDate,
      setUseCagrCustomDate = _ref.setUseCagrCustomDate;

  var _useState = (0,react.useState)(false),
      hasEverOpened = _useState[0],
      setHasEverOpened = _useState[1];

  (0,react.useEffect)(function () {
    if (open) {
      setHasEverOpened(true);
    }
  }, [open]);

  var onModalClick = function onModalClick(e) {
    if (e.target.classList.contains('close-on-click')) {
      onClose();
    }
  };

  return hasEverOpened && /*#__PURE__*/react_dom.createPortal( /*#__PURE__*/(0,jsx_runtime.jsx)(Modal.StyledModal, {
    className: "close-on-click",
    onClick: onModalClick,
    style: {
      display: open ? 'flex' : 'none'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContent, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledHeader, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
          children: inputsData.CustomPricingModalTitle
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormButton, {
          style: {
            maxHeight: '60px',
            marginLeft: '3rem'
          },
          onClick: onClose,
          children: "Close"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledFormContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(custom_pricing_modal_StyledCheckboxContainer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "increase-by-percentage-checkbox",
            children: inputsData.CustomPricingModalIncreaseValueByPercentage
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox, {
            _id: "increase-by-percentage-checkbox",
            checked: increaseValueByPercentage,
            onChange: function onChange(e) {
              return increaseValueByPercentageOnChange(e.target.checked);
            }
          })]
        }), !increaseValueByPercentage && /*#__PURE__*/(0,jsx_runtime.jsxs)(custom_pricing_modal_StyledCheckboxContainer, {
          style: {
            marginBottom: '1.5rem'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "custom-date",
            children: inputsData.annualGrowthRateFromDate
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox, {
            _id: "custom-date",
            checked: useCagrCustomDate,
            onChange: function onChange(e) {
              return setUseCagrCustomDate(e.target.checked);
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [!useCagrCustomDate && !increaseValueByPercentage && /*#__PURE__*/(0,jsx_runtime.jsx)(predictionInputs["default"], {
            inputsData: inputsData
          }), useCagrCustomDate && /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCustomDateContainer, {
            id: "cagrCustomDate" // label={
            //     (useStackingAmount
            //         ? inputsData.customGoalDatePickerLabelPredictByInvestment
            //         : inputsData.customGoalDatePickerLabelPredictByGoal) +
            //     (cagrCustomDatePercentage ? ' - ' + cagrCustomDatePercentage + '%' : '')
            // }
            ,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCustomDateInputContainer, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: inputsData.customDate
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.DatePicker, {
                minDate: BITCOIN_API_BEGIN_DATE // maxDate={new Date()}
                ,
                id: "cagrCustomDate",
                value: cagrCustomDate,
                onChange: function onChange(val) {
                  if ((0,date/* isBeforeBitcoinExistence */.ms)((0,date/* getYMD */.qw)(val))) {
                    alert(inputsData.beforeBitcoinExistenceMessage);
                  } else {
                    setCagrCustomDate(val);
                  }
                },
                maxDate: (0,date/* dateOnly */.hp)(new Date()),
                style: {
                  border: 'none'
                }
              })]
            }), cagrCustomDatePercentage && /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCustomDateInputContainer, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: inputsData.annualGrowthRate
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.FormattedInput, {
                value: cagrCustomDatePercentage,
                readOnly: true,
                format: function format(val) {
                  return "".concat(val, "%");
                }
              })]
            })]
          }), Boolean(increaseValueByPercentage) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledPercentageIncrease, {
              children: inputsData.percentageIncrease
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
              name: "growth",
              type: "number",
              initialValue: inputsData.defaults.growthRate || undefined,
              validate: function validate(val) {
                if (Number(val) == -100) return 'Cannot lose 100% value in 1 year.';
              },
              children: function children(_ref2) {
                var input = _ref2.input;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.PercentInput, custom_pricing_modal_objectSpread({}, input));
              }
            })]
          })]
        })]
      })]
    })
  }), (_document = document) === null || _document === void 0 ? void 0 : _document.body);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js + 1 modules
var differenceInDays = __webpack_require__(29383);
;// CONCATENATED MODULE: ./components/content/calculator/inputs/pricePointsInput/pricePointsInput.js



function pricePointsInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function pricePointsInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? pricePointsInput_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : pricePointsInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var PricePointsInput = function PricePointsInput(_ref) {
  var inputsData = _ref.inputsData,
      setShowPricePredictionModal = _ref.setShowPricePredictionModal;
  var form = (0,react_final_form_es.useForm)();

  var _useFormState = (0,react_final_form_es.useFormState)(),
      _useFormState$values = _useFormState.values,
      growth = _useFormState$values.growth,
      goalDateSelect = _useFormState$values.goalDateSelect,
      goalDate = _useFormState$values.goalDate,
      currency = _useFormState$values.currency,
      cagrDateSelect = _useFormState$values.cagrDateSelect,
      cagrCustomDate = _useFormState$values.cagrCustomDate,
      useStackingAmount = _useFormState$values.useStackingAmount,
      showPrediction = _useFormState$values.showPrediction,
      _useFormState$values$ = _useFormState$values.pricePredictions,
      pricePredictions = _useFormState$values$ === void 0 ? [] : _useFormState$values$,
      customPrices = _useFormState$values.customPrices,
      growthError = _useFormState.errors.growth;

  var _cagrDateSelectOptions = inputsData.cagrDateSelectOptions,
      customGoalDateOptionLabel = inputsData.customGoalDateOptionLabel,
      helpTexts = inputsData.helpTexts;

  var _useState = (0,react.useState)(_cagrDateSelectOptions),
      cagrDateSelectOptions = _useState[0],
      setCagrDateSelectOptions = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showCustomPricingModal = _useState2[0],
      setShowCustomPricingModal = _useState2[1];

  var _useCryptoValue = (0,useCryptoValue/* default */.Z)(),
      _useCryptoValue$data = _useCryptoValue.data,
      btcPrices = _useCryptoValue$data === void 0 ? {} : _useCryptoValue$data;

  var _useState3 = (0,react.useState)(null),
      oldPrice = _useState3[0],
      setOldPrice = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      loadingGrowthRate = _useState4[0],
      setLoadingGrowthRate = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      increaseValueByPercentage = _useState5[0],
      _setIncreaseValueByPercentage = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      cagrCustomDatePercentage = _useState6[0],
      setCagrCustomDatePercentage = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      useCagrCustomDate = _useState7[0],
      _setUseCagrCustomDate = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      hasFetched = _useState8[0],
      setHasFetched = _useState8[1];

  var btcPriceNow = currency ? btcPrices[currency] : btcPrices['USD'];

  var setUseCagrCustomDate = function setUseCagrCustomDate(val) {
    form.change('showPrediction', !val);

    _setUseCagrCustomDate(val);
  };

  var setIncreaseValueByPercentage = function setIncreaseValueByPercentage(val) {
    var defaultOption = getCAGRInitialValue(cagrDateSelectOptions);
    var growthRateToUse = inputsData.defaults.growthRate !== null ? inputsData.defaults.growthRate : defaultOption;

    if (val) {
      _setUseCagrCustomDate(!val);

      form.change('growth', growthRateToUse);
    }

    _setIncreaseValueByPercentage(val);
  };

  var calculateCagrPercentage = function calculateCagrPercentage(price, diffMonthsOrDays, options) {
    return Math.round((Math.pow(btcPrices['USD'] / price, 1 / (diffMonthsOrDays / (options !== null && options !== void 0 && options.diffInDays ? 365 : 12))) - 1) * 100);
  }; // Calls the old price api to get the value from selected date


  (0,react.useEffect)(function () {
    if (!cagrCustomDate) {
      return;
    }

    var formattedApiDate = (0,date/* formatDateForHistoricApi */.p$)((0,date/* getYMD */.qw)(cagrCustomDate));
    fetchHistoricBtcPrice({
      date: formattedApiDate
    }).then(function (_ref2) {
      var price = _ref2.USD;
      var percentage = calculateCagrPercentage(price, Math.abs((0,differenceInDays/* default */.Z)(new Date(), cagrCustomDate)), {
        diffInDays: true
      });
      form.change('showPrediction', false);
      setCagrCustomDatePercentage(percentage);
      form.change('growth', percentage);
    });
  }, [cagrCustomDate]);

  var setCagrCustomDate = function setCagrCustomDate(val) {
    form.change('cagrCustomDate', val);
  };

  (0,react.useEffect)(function () {
    // If btcPriceNow is not available or if we've already fetched for this value, do nothing
    if (!btcPriceNow || hasFetched) {
      return;
    }

    setLoadingGrowthRate(true);

    var dates = _cagrDateSelectOptions.map(function (d) {
      var newDate = (0,date/* getOppositeDate */.mA)(d.durationISO);
      var period = dist.parse(d.durationISO);
      return {
        ymd: (0,date/* getYMD */.qw)(newDate),
        diffMonths: period.years * 12 + period.months
      };
    });

    fetchMultipleHistoricBtcPrice({
      dates: dates.map(function (d) {
        return d.ymd;
      })
    }).then(function (priceRange) {
      var newOptions = _cagrDateSelectOptions.map(function (option, index) {
        option.price = priceRange[index]['USD'];
        option.percentage = calculateCagrPercentage(option.price, dates[index].diffMonths);
        return option;
      });

      var defaultOption = newOptions.find(function (opt) {
        return opt["default"];
      });
      setCagrDateSelectOptions(newOptions);
      form.change('growth', defaultOption.percentage); // Mark as fetched

      setHasFetched(true);
    })["finally"](function () {
      setLoadingGrowthRate(false);
    });
  }, [_cagrDateSelectOptions, btcPriceNow]); // Other parts of the app need this value for the logic

  react.useEffect(function () {
    form.change('showPrediction', !increaseValueByPercentage);
    resetPricePredictions();
  }, [increaseValueByPercentage]);
  react.useEffect(function () {
    if (!isNaN(cagrDateSelect)) {
      form.change('growth', cagrDateSelect);
    }

    if (isNaN(cagrDateSelect)) {
      var cagrPercentage = cagrDateSelect === null || cagrDateSelect === void 0 ? void 0 : cagrDateSelect.split('_')[0];
      form.change('growth', cagrPercentage);
    }
  }, [cagrDateSelect]);

  var setGrowthRateBasedOnTheOldPrice = function setGrowthRateBasedOnTheOldPrice(btcPriceNow, oldPrice) {
    form.change('growth', Math.floor(btcPriceNow / oldPrice * 100) - 100);
  };

  react.useEffect(function () {
    if (btcPriceNow && oldPrice) {
      setGrowthRateBasedOnTheOldPrice(btcPriceNow, oldPrice);
    }
  }, [oldPrice, btcPriceNow, customPrices]); // Set the initial value for the growth rate to the default option

  react.useEffect(function () {
    var defaultOption = getCAGRInitialValue(cagrDateSelectOptions);

    if (!customPrices) {
      form.change('growth', defaultOption);
      form.change('cagrDateSelect', defaultOption);

      if (defaultOption) {
        form.change('growth', defaultOption);
      }

      if (!increaseValueByPercentage) {
        setIncreaseValueByPercentage(true);
      }
    } else {
      if (increaseValueByPercentage) {
        setIncreaseValueByPercentage(false);
      }
    }
  }, [customPrices]);

  var resetPricePredictions = function resetPricePredictions() {
    form.change('pricePredictions', [{
      date: new Date(),
      value: btcPriceNow
    }, {
      date: goalDate,
      value: ''
    }]);
  };

  react.useEffect(function () {
    if (form && btcPriceNow) {
      if (!increaseValueByPercentage) {
        // always reset
        resetPricePredictions();
      } else {
        form.change('pricePredictions', [// new price today
        {
          date: new Date(),
          value: btcPriceNow
        }].concat((0,toConsumableArray/* default */.Z)(pricePredictions.length >= 2 ? pricePredictions.slice(1, pricePredictions.length) : []), (0,toConsumableArray/* default */.Z)(pricePredictions.find(function (pred) {
          return (0,isSameDay/* default */.Z)(pred.date, goalDate);
        }) ? [] : [{
          date: goalDate,
          value: ''
        }])));
      }
    }
  }, [btcPriceNow, goalDate]); // eslint-disable-line react-hooks/exhaustive-deps

  function getCAGRInitialValue(cagrDateSelectOptions) {
    if (!cagrDateSelectOptions) {
      return 'CUSTOM';
    }

    var defaultOption = cagrDateSelectOptions.find(function (opt) {
      return opt["default"];
    });
    return "".concat(defaultOption.percentage, "_").concat(defaultOption.durationISO);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
      name: "pricePredictions",
      validate: function validate(predictions) {
        if ((predictions || []).filter(function (_ref3) {
          var value = _ref3.value;
          return value < 0;
        }).length > 0) {
          return 'Negative prices not permitted.';
        }
      },
      children: function children(_ref4) {
        var meta = _ref4.meta;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_form.StyledField, {
          style: pricePointsInput_objectSpread({}, cagrDateSelect === 'CUSTOM' && {
            marginBottom: '0.8rem'
          }),
          label: inputsData.pricePredictionsLabel,
          help: helpTexts.pricePredictions,
          upperRightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
            name: "customPrices",
            initialValue: false,
            type: "checkbox",
            children: function children(_ref5) {
              var input = _ref5.input;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCustomPrices, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                    htmlFor: "custom-prices-checkbox",
                    children: inputsData.SetCustomPricesText
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox, {
                    _id: "custom-prices-checkbox",
                    onChange: input.onChange,
                    checked: input.checked
                  })]
                })
              });
            }
          }),
          children: [!customPrices && !loadingGrowthRate && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
              name: "cagrDateSelect",
              initialValue: getCAGRInitialValue(cagrDateSelectOptions),
              children: function children(_ref6) {
                var input = _ref6.input;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(form_select/* Select */.P, pricePointsInput_objectSpread(pricePointsInput_objectSpread({}, input), {}, {
                  id: "goalDateSelect2",
                  children: (cagrDateSelectOptions || []).map(function (_ref7, idx) {
                    var durationISO = _ref7.durationISO,
                        Label = _ref7.Label,
                        percentage = _ref7.percentage;
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("option", {
                      value: "".concat(percentage, "_").concat(durationISO),
                      children: [Label, ": ", percentage, "%"]
                    }, idx);
                  })
                }));
              }
            })
          }), !customPrices && loadingGrowthRate && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.FormattedInput, {
            value: "Loading...",
            format: function format(val) {
              return "".concat(val);
            }
          }), customPrices && /*#__PURE__*/(0,jsx_runtime.jsx)(FormButton, {
            onClick: function onClick() {
              return setShowCustomPricingModal(true);
            },
            children: inputsData.AddCustomPricingButtonText
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CustomPricingModal, {
            setCagrCustomDate: setCagrCustomDate,
            cagrCustomDate: cagrCustomDate,
            cagrCustomDatePercentage: cagrCustomDatePercentage,
            useStackingAmount: useStackingAmount,
            useCagrCustomDate: useCagrCustomDate,
            setUseCagrCustomDate: setUseCagrCustomDate,
            increaseValueByPercentageOnChange: function increaseValueByPercentageOnChange(val) {
              return setIncreaseValueByPercentage(val);
            },
            inputsData: inputsData,
            increaseValueByPercentage: increaseValueByPercentage,
            open: showCustomPricingModal,
            onClose: function onClose() {
              return setShowCustomPricingModal(false);
            }
          })]
        });
      }
    })
  });
};

/* harmony default export */ var pricePointsInput = (PricePointsInput);
// EXTERNAL MODULE: ./components/content/calculator/calculationContext.js
var calculationContext = __webpack_require__(93138);
;// CONCATENATED MODULE: ./components/content/calculator/inputs/stackingAmount.js


function stackingAmount_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function stackingAmount_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? stackingAmount_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : stackingAmount_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var StackingAmountField = function StackingAmountField(_ref) {
  var inputsData = _ref.inputsData;

  var _useCalculation = (0,calculationContext/* useCalculation */.C)(),
      _useCalculation$curre = _useCalculation.currency,
      currency = _useCalculation$curre === void 0 ? "USD" : _useCalculation$curre;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
    name: "stackingAmount",
    type: "number",
    validate: function validate(val) {
      if (Number(val) < 0) return "Value cannot be negative.";
    },
    initialValue: inputsData.defaults.stackingAmount,
    children: function children(_ref2) {
      var input = _ref2.input,
          meta = _ref2.meta;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.StyledField, {
        label: inputsData.stackingAmountLabel,
        error: meta.touched && meta.error,
        help: inputsData.helpTexts.stackingAmount,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(utils_currency/* CurrencyInput */.LH, stackingAmount_objectSpread(stackingAmount_objectSpread({
          currency: currency
        }, input), {}, {
          min: 0,
          $error: meta.touched && meta.error
        }))
      });
    }
  });
};

/* harmony default export */ var stackingAmount = (StackingAmountField);
;// CONCATENATED MODULE: ./components/atoms/TabSwitch.js


var TabSwitch_templateObject, TabSwitch_templateObject2, TabSwitch_templateObject3, TabSwitch_templateObject4, TabSwitch_templateObject5;




var SwitchWrapper = styled_components_browser_esm/* default.div */.ZP.div(TabSwitch_templateObject || (TabSwitch_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  background: ", ";\n  border-radius: 5px;\n  height: 40px;\n  position: relative;\n"])), function (_ref) {
  var $primary = _ref.$primary,
      theme = _ref.theme;
  return $primary ? theme.colors.primaryLowOpacity : theme.colors.tabSwitchUnselected;
});
var LabelsWrapper = styled_components_browser_esm/* default.div */.ZP.div(TabSwitch_templateObject2 || (TabSwitch_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var Label = styled_components_browser_esm/* default.button */.ZP.button(TabSwitch_templateObject3 || (TabSwitch_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 1;\n  background: none;\n  border: none;\n  color: ", ";\n  cursor: pointer;\n  height: 100%;\n  z-index: 20;\n\n  transition-property: color;\n  transition-duration: 200ms;\n"])), function (_ref2) {
  var theme = _ref2.theme,
      $selected = _ref2.$selected,
      $primary = _ref2.$primary;
  return $selected ? $primary ? theme.colors.textInverse : theme.colors.primary : theme.colors.text;
});
var PillWrapper = styled_components_browser_esm/* default.div */.ZP.div(TabSwitch_templateObject4 || (TabSwitch_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: ", ";\n"])), function (_ref3) {
  var $primary = _ref3.$primary;
  return $primary ? '0' : '.2rem';
});
var Pill = styled_components_browser_esm/* default.div */.ZP.div(TabSwitch_templateObject5 || (TabSwitch_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: ", ";\n  background: ", ";\n  border-radius: 5px;\n  z-index: 10;\n  height: 100%;\n  width: ", "%;\n  position: relative;\n  left: ", "%;\n\n  transition-property: left;\n  transition-duration: 200ms;\n  transition-timing-function: ease-out;\n"])), function (_ref4) {
  var $index = _ref4.$index;
  return $index >= 0 ? 'block' : 'hidden';
}, function (_ref5) {
  var $primary = _ref5.$primary,
      theme = _ref5.theme;
  return $primary ? theme.colors.primary : theme.colors.tabSwitchSelected;
}, function (_ref6) {
  var $count = _ref6.$count;
  return 100 / $count;
}, function (_ref7) {
  var $index = _ref7.$index,
      $count = _ref7.$count;
  return $index * (100 / $count);
});
function TabSwitch(_ref8) {
  var tabs = _ref8.tabs,
      value = _ref8.value,
      onChange = _ref8.onChange,
      primary = _ref8.primary;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SwitchWrapper, {
    $primary: primary,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PillWrapper, {
      $primary: primary,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Pill, {
        $index: tabs.findIndex(function (tab) {
          return tab.value === value;
        }),
        $count: tabs.length,
        $primary: primary
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabelsWrapper, {
      children: tabs.map(function (tab) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
          $selected: tab.value === value,
          onClick: function onClick() {
            return onChange(tab.value);
          },
          $primary: primary,
          children: tab.label
        }, tab.value);
      })
    })]
  });
}
// EXTERNAL MODULE: ./utils/convertBtcSats.js
var convertBtcSats = __webpack_require__(72583);
// EXTERNAL MODULE: ./node_modules/react-detect-offline/dist/index.js
var react_detect_offline_dist = __webpack_require__(74764);
// EXTERNAL MODULE: ./node_modules/react-mitt/dist/react-mitt.es.js
var react_mitt_es = __webpack_require__(75492);
;// CONCATENATED MODULE: ./components/offline-modal/index.js


var offline_modal_templateObject, offline_modal_templateObject2, offline_modal_templateObject3, offline_modal_templateObject4, offline_modal_templateObject5, _templateObject6, _templateObject7, _templateObject8;






var offline_modal_StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal.StyledModal)(offline_modal_templateObject || (offline_modal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 999;\n  background: rgba(102, 102, 102, 0.5);\n  overflow: auto;\n"])));
var offline_modal_StyledContent = (0,styled_components_browser_esm/* default */.ZP)(Modal.Content)(offline_modal_templateObject2 || (offline_modal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-height: 90%;\n  padding: 2.2rem 2rem 0 2rem;\n  background: ", ";\n  overflow: hidden;\n  position: relative;\n  border-radius: 10px;\n  @media screen and (min-width: ", ") {\n    width: 88rem;\n    max-width: 90%;\n    padding: 3.2rem 0 0 4rem;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.modalBackground;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.sm.minWidth;
});
var offline_modal_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Text.H4)(offline_modal_templateObject3 || (offline_modal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-align: left;\n  font-size: 3rem;\n  width: 100%;\n  color: ", ";\n  letter-spacing: 0.1rem;\n  margin-bottom: 1.4rem;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.isDark ? '#fff' : 'inherit';
});
var StyledDescription = (0,styled_components_browser_esm/* default */.ZP)(Text/* Paragraph */.nv)(offline_modal_templateObject4 || (offline_modal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: 1.25;\n  font-size: 1.35rem;\n  padding-bottom: 0.7rem;\n"])));
var StyledOrderedList = (0,styled_components_browser_esm/* default */.ZP)(OL)(offline_modal_templateObject5 || (offline_modal_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-align: left;\n  width: 100%;\n  padding-left: 2rem;\n  margin-bottom: 8rem;\n"])));
var StyledLI = (0,styled_components_browser_esm/* default */.ZP)(LI)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-bottom: 0.2rem;\n"])));
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Buttons/* Button */.zx)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: 800;\n  padding: 0.5rem 1.1rem;\n  font-size: 1.2rem;\n  font-family: 'Inter', sans-serif;\n  transition: 300ms all;\n  border-radius: 999px;\n  vertical-align: middle;\n  display: inline-flex;\n  gap: 1rem;\n\n  &:hover {\n    background: ", ";\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primaryHover;
});
var StyledImage = styled_components_browser_esm/* default.img */.ZP.img(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: 0;\n  width: 50rem;\n  --y-transform: 7.7rem;\n  --x-transform: 3rem;\n  right: unset;\n  left: 50%;\n  height: 30rem;\n  transform: translate(calc(-50% - var(--x-transform) + 2.8rem), 5.4rem);\n  @media screen and (min-width: ", ") {\n    height: 40rem;\n    transform: translate(var(--x-transform), var(--y-transform));\n    right: 0;\n    left: unset;\n  }\n\n  @media screen and (max-width: 370px) {\n    height: 24rem;\n  }\n  @media screen and (max-width: 500px) {\n    --x-transform: 2.76rem;\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.md.minWidth;
});
;// CONCATENATED MODULE: ./images/disconnect-image.svg
/* harmony default export */ var disconnect_image = ({"src":"/_next/static/media/disconnect-image.a6f868bd.svg","height":3000,"width":4000});
;// CONCATENATED MODULE: ./components/offline-modal/raw-offline-modal.js







var areasMobile = "\n  description\n  image\n";
var areas = "\ndescription image\n";
function RawOfflineModal(_ref) {
  var data = _ref.data,
      onClose = _ref.onClose;

  var onModalClick = function onModalClick(e) {
    if (e.target.classList.contains('close-on-click')) {
      onClose();
    }
  };

  return /*#__PURE__*/react_dom.createPortal( /*#__PURE__*/(0,jsx_runtime.jsx)(offline_modal_StyledModal, {
    className: "close-on-click",
    onClick: onModalClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(offline_modal_StyledContent, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Composition */.fS, {
        templateCols: "minmax(0, 1fr)",
        areas: areasMobile,
        areasMd: areas,
        children: function children(Areas) {
          var _data$steps;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Areas.Description, {
              paddingBottom: "2rem",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(offline_modal_StyledTitle, {
                children: data === null || data === void 0 ? void 0 : data.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledDescription, {
                children: data === null || data === void 0 ? void 0 : data.description
              }), (data === null || data === void 0 ? void 0 : (_data$steps = data.steps) === null || _data$steps === void 0 ? void 0 : _data$steps.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledOrderedList, {
                children: data === null || data === void 0 ? void 0 : data.steps.map(function (step) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLI, {
                    children: step
                  }, step);
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, {
                onClick: onClose,
                $primary: true,
                children: data === null || data === void 0 ? void 0 : data.buttonLabel
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Areas.Image, {
              heightSm: "25rem",
              heightMd: "32rem",
              height: "22rem",
              widthMd: "37rem",
              widthLg: "44rem",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImage, {
                src: disconnect_image.src
              })
            })]
          });
        }
      })
    })
  }), document.body);
}
;// CONCATENATED MODULE: ./components/content/offline-modal.js






function OfflineModal(_ref) {
  var _workOfflineSection$i;

  var workOfflineSection = _ref.workOfflineSection;

  var _useState = (0,react.useState)(false),
      show = _useState[0],
      setShow = _useState[1];

  var _useState2 = (0,react.useState)(false),
      forcedShow = _useState2[0],
      setForcedShow = _useState2[1];

  var _useMitt = (0,react_mitt_es/* useMitt */.V)(),
      emitter = _useMitt.emitter;

  (0,react.useEffect)(function () {
    emitter.on('show-offline-modal', function () {
      return setForcedShow(true);
    });
  }, []);
  var data = {
    title: workOfflineSection === null || workOfflineSection === void 0 ? void 0 : workOfflineSection.title,
    description: workOfflineSection === null || workOfflineSection === void 0 ? void 0 : workOfflineSection.text,
    steps: workOfflineSection === null || workOfflineSection === void 0 ? void 0 : (_workOfflineSection$i = workOfflineSection.instructions) === null || _workOfflineSection$i === void 0 ? void 0 : _workOfflineSection$i.map(function (i) {
      return i.text;
    }),
    buttonLabel: workOfflineSection === null || workOfflineSection === void 0 ? void 0 : workOfflineSection.goBackButtonText
  };

  if (forcedShow) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(RawOfflineModal, {
      data: data,
      onClose: function onClose() {
        return setForcedShow(false);
      }
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: show ? /*#__PURE__*/(0,jsx_runtime.jsx)(react_detect_offline_dist/* Offline */.B6, {
      polling: {
        url: "https://ipv4.icanhazip.com"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RawOfflineModal, {
        data: data,
        onClose: function onClose() {
          return setShow(false);
        }
      })
    }) : null
  });
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/jotai/esm/react.mjs
var esm_react = __webpack_require__(48583);
// EXTERNAL MODULE: ./atoms/calculator.js
var calculator = __webpack_require__(34822);
// EXTERNAL MODULE: ./utils/logicContext.js
var logicContext = __webpack_require__(73839);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react-toggle/style.css
var style = __webpack_require__(11617);
// EXTERNAL MODULE: ./node_modules/react-toggle/dist/component/index.js
var component = __webpack_require__(80888);
;// CONCATENATED MODULE: ./components/atoms/toggle.js



var _excluded = ["leftLabel", "rightLabel"];

var toggle_templateObject;

function toggle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function toggle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? toggle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : toggle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var StyledReactToggle = (0,styled_components_browser_esm/* default */.ZP)(component/* default */.Z)(toggle_templateObject || (toggle_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  .react-toggle-track {\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n  }\n\n  &.react-toggle--checked {\n    .react-toggle-track {\n      background-color: ", ";\n    }\n\n    .react-toggle-thumb {\n      border-color: ", ";\n    }\n  }\n\n\n    &:not(.react-toggle--checked) {\n    .react-toggle-track {\n      background-color: #d1d1d1;\n    }\n\n    .react-toggle-thumb {\n      border-color: #d1d1d1;\n    }\n  }\n\n  &:not(.react-toggle--checked):hover {\n    .react-toggle-track {\n      background-color: #c6c6c6;\n    }\n  }\n\n  &.react-toggle--checked:hover {\n    .react-toggle-track {\n      background-color: ", ";\n    }\n  }\n\n  .react-toggle-thumb {\n    background-color: #fff;\n      // border-color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
});
var StyledToggleParagraph = (0,styled_components_browser_esm/* default */.ZP)(Text/* Paragraph */.nv)({
  maxHeight: '41px',
  lineHeight: 1.5
});

var Toggle = function Toggle(_ref5) {
  var leftLabel = _ref5.leftLabel,
      rightLabel = _ref5.rightLabel,
      props = (0,objectWithoutProperties/* default */.Z)(_ref5, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(esm/* Box */.xu, {
    flex: true,
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    children: [leftLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Paragraph */.nv, {
      $padding: "initial",
      children: leftLabel
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledReactToggle, toggle_objectSpread({
      icons: false
    }, props)), rightLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledToggleParagraph, {
      $padding: "initial",
      children: rightLabel
    })]
  });
};

/* harmony default export */ var toggle = (Toggle);
// EXTERNAL MODULE: ./components/atoms/SVG.js
var SVG = __webpack_require__(9363);
;// CONCATENATED MODULE: ./components/content/calculator/inputs/advancedOptions.js



function advancedOptions_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function advancedOptions_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? advancedOptions_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : advancedOptions_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























function validateStack(currStack, isSats, inputProps, supplyLogic) {
  var BTCSupplyLimit = supplyLogic.BTCSupplyLimit,
      SatsSupplyLimit = supplyLogic.SatsSupplyLimit;
  var goalAmountBTCOverLimitError = inputProps.goalAmountBTCOverLimitError,
      goalAmountSatsOverLimitError = inputProps.goalAmountSatsOverLimitError;
  if (isSats && currStack >= Number(SatsSupplyLimit)) return goalAmountSatsOverLimitError;
  if (!isSats && currStack >= Number(BTCSupplyLimit)) return goalAmountBTCOverLimitError;
} // TODO: Move to a hook


function usePrevious(value) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
} // TODO: Move to styles


var AdvancedOptionsFormButton = function AdvancedOptionsFormButton(_ref) {
  var setShowAdvancedOptions = _ref.setShowAdvancedOptions;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    style: {
      display: 'flex'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormButton, {
      $isSecondary: true,
      onClick: setShowAdvancedOptions,
      children: "Advanced Options"
    })
  });
}; // TODO: Clean this up

var AdvancedOptionsModal = function AdvancedOptionsModal(_ref2) {
  var _document;

  var isOpen = _ref2.isOpen,
      handleClose = _ref2.handleClose,
      increaseWithInflation = _ref2.increaseWithInflation,
      calculateFuturePurchasingPower = _ref2.calculateFuturePurchasingPower,
      workOfflineSection = _ref2.workOfflineSection,
      inputsData = _ref2.inputsData;

  var _useAtom = (0,esm_react/* useAtom */.KO)(calculator/* startingStackAtom */.$_),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      startingStack = _useAtom2[0],
      setStartingStack = _useAtom2[1];

  var _useAtom3 = (0,esm_react/* useAtom */.KO)(calculator/* avgCostPerBTCPriceAtom */.fm),
      _useAtom4 = (0,slicedToArray/* default */.Z)(_useAtom3, 2),
      startingStackAvgBTC = _useAtom4[0],
      setStartingStackAvgBTC = _useAtom4[1];

  var _useFormState = (0,react_final_form_es.useFormState)(),
      isSatoshis = _useFormState.values.isSatoshis;

  var prevIsSatoshi = usePrevious(isSatoshis);

  var _useState = (0,react.useState)(false),
      hasAvgBtcBeenEdited = _useState[0],
      setHasAvgBtcBeenEdited = _useState[1];

  var _useCalculation = (0,calculationContext/* useCalculation */.C)(),
      goal = _useCalculation.goal,
      useStackingAmount = _useCalculation.useStackingAmount,
      _useCalculation$curre = _useCalculation.currency,
      currency = _useCalculation$curre === void 0 ? 'USD' : _useCalculation$curre;

  var logic = (0,logicContext/* useLogic */.Z)();

  var _useMitt = (0,react_mitt_es/* useMitt */.V)(),
      emitter = _useMitt.emitter;

  var _useCryptoValue = (0,useCryptoValue/* default */.Z)(),
      data = _useCryptoValue.data;

  var priceNow = data && data[currency];
  var avgBTCPriceToUse = !hasAvgBtcBeenEdited ? priceNow : startingStackAvgBTC;

  var _format = function format(val) {
    val = (0,utils_currency/* scientificToNumber */.L9)(val || 0);
    return "".concat((0,utils_currency/* numberWithCommas */.x6)(val), " ").concat((0,utils_currency/* getUnitName */.ij)(val, isSatoshis));
  }; // TODO: Find a way to sort the value going from high to low when BTC to Sats is changed.


  (0,react.useEffect)(function () {
    prevIsSatoshi != isSatoshis && isSatoshis ? setStartingStack(Number((0,convertBtcSats/* toSat */.Fd)(startingStack))) : setStartingStack(Number((0,convertBtcSats/* toBTC */.mg)(startingStack)));
  }, [isSatoshis]);
  var minStackingAmount = useStackingAmount || !goal ? isSatoshis ? 1 : 0.00000001 : goal;
  var maxStackingAmount = useStackingAmount || !goal ? isSatoshis ? 1 * logic.SatsSupplyLimit : 1 * logic.BTCSupplyLimit : goal;

  var handleStartingStack = function handleStartingStack(e) {
    var newVal = e.target.value;
    if (!!prevIsSatoshi) return setStartingStack(newVal);
    if (prevIsSatoshi != isSatoshis && isSatoshis) return setStartingStack(newVal);
    return setStartingStack(newVal);
  };

  var handleAvgBTCStackChange = function handleAvgBTCStackChange(newVal) {
    setHasAvgBtcBeenEdited(true);
    setStartingStackAvgBTC(newVal);
  };

  var isInflationDisabled = !increaseWithInflation && !calculateFuturePurchasingPower;
  return isOpen && /*#__PURE__*/react_dom.createPortal( /*#__PURE__*/(0,jsx_runtime.jsx)(Modal.StyledModal, {
    title: "Advanced Options",
    onClose: handleClose,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContent, {
      $width: 350,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledHeader, {
        $col: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
          children: "Advanced Options"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSubTitle, {
          children: useStackingAmount ? inputsData.predictByInvestmentAmount : inputsData.predictByGoal
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledFormContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
          name: "currentStack",
          type: "number",
          validate: function validate(val) {
            if (Number(val) < 0) return 'Value cannot be negative.';
          },
          children: function children() {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.StyledField, {
              label: inputsData.currentStackLabel // error={isCurrentStackError()}
              ,
              error: validateStack(startingStack, isSatoshis, inputsData, logic),
              help: inputsData.helpTexts.startingStack,
              upperRightContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledButton, {
                onClick: function onClick() {
                  return emitter.emit('show-offline-modal');
                },
                $primary: true,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SVG/* Disconnect */.cH, {}), workOfflineSection === null || workOfflineSection === void 0 ? void 0 : workOfflineSection.buttonText]
              }),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.FormattedInput, {
                type: "number",
                noNegative: true,
                value: startingStack,
                onChange: handleStartingStack,
                id: "currentStackInput",
                step: isSatoshis ? 1 : 0.00000001,
                min: minStackingAmount,
                max: maxStackingAmount,
                format: function format() {
                  return _format(startingStack);
                },
                $error: validateStack(startingStack, isSatoshis, inputsData, logic)
              })
            });
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.StyledField, {
          label: inputsData.avgStackCostLabel,
          help: inputsData.helpTexts.avgStackCost,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(utils_currency/* CurrencyInput */.LH, {
            type: "number",
            id: "avgBTCStackCostInput",
            currency: currency,
            noNegative: true,
            step: 1,
            value: avgBTCPriceToUse,
            min: 0,
            max: maxStackingAmount,
            onChange: function onChange(e) {
              return handleAvgBTCStackChange(e.target.valueAsNumber);
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
            name: "calculateFuturePurchasingPower",
            type: "checkbox",
            initialValue: false,
            children: function children(_ref3) {
              var input = _ref3.input,
                  meta = _ref3.meta;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.StyledField, {
                style: advancedOptions_objectSpread({}, useStackingAmount && {
                  marginBottom: '0.1rem',
                  marginTop: '-0.5rem'
                }),
                error: meta.touched && meta.error,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(toggle, {
                  id: "calculation-future-purchasing-power",
                  leftLabel: "",
                  rightLabel: inputsData.CalculateFuturePurchasingPower,
                  checked: input.checked,
                  onChange: input.onChange
                })
              });
            }
          }), useStackingAmount && /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
            name: "increaseWithInflation",
            type: "checkbox",
            initialValue: false,
            children: function children(_ref4) {
              var input = _ref4.input,
                  meta = _ref4.meta;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.StyledField, {
                style: {
                  marginTop: '-1rem'
                },
                error: meta.touched && meta.error,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(toggle, {
                  id: "icrease-with-inflation",
                  leftLabel: "",
                  rightLabel: inputsData.increaseWithInflationText,
                  checked: input.checked,
                  onChange: input.onChange
                })
              });
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
            name: "inflationPercent",
            initialValue: 2,
            children: function children(_ref5) {
              var input = _ref5.input,
                  meta = _ref5.meta;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.StyledField, {
                isDisabled: isInflationDisabled,
                label: inputsData.inflationRateLabel,
                error: meta.touched && meta.error,
                help: inputsData.helpTexts.inflationRate,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.PercentInput, advancedOptions_objectSpread(advancedOptions_objectSpread({
                  isDisabled: isInflationDisabled
                }, input), {}, {
                  step: 0.5,
                  $error: meta.touched && meta.error
                }))
              });
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormButton, {
          style: {
            width: '100%'
          },
          onClick: handleClose,
          children: "Confirm"
        })]
      })]
    })
  }), (_document = document) === null || _document === void 0 ? void 0 : _document.body);
};
;// CONCATENATED MODULE: ./components/content/calculator/inputs/index.js


function inputs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function inputs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? inputs_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : inputs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var fields = "\n    calculatorType\n    bitcoinFormat\n    currency\n    stackingFrequency\n    goal\n    goalDate\n    pricePredictions\n    advancedModal\n";

var CalculatorInputs = function CalculatorInputs(_ref) {
  var inputsData = _ref.inputsData,
      workOfflineSection = _ref.workOfflineSection,
      showPricePredictionModal = _ref.showPricePredictionModal,
      setShowPricePredictionModal = _ref.setShowPricePredictionModal;
  var helpTexts = inputsData.helpTexts;

  var _useFormState = (0,react_final_form_es.useFormState)(),
      values = _useFormState.values;

  var _values$useStackingAm = values.useStackingAmount,
      useStackingAmount = _values$useStackingAm === void 0 ? true : _values$useStackingAm,
      _values$increaseWithI = values.increaseWithInflation,
      increaseWithInflation = _values$increaseWithI === void 0 ? false : _values$increaseWithI,
      isSatoshis = values.isSatoshis,
      calculateFuturePurchasingPower = values.calculateFuturePurchasingPower;
  var form = (0,react_final_form_es.useForm)();

  var _useState = (0,react.useState)(false),
      showAdvancedOptions = _useState[0],
      _setShowAdvancedOptions = _useState[1];

  function handleCalculatorTypeChange(input) {
    var onChange = input.onChange,
        checked = input.checked;
    form.change('increaseWithInflation', false);
    onChange(!checked);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OfflineModal, {
      workOfflineSection: workOfflineSection
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AdvancedOptionsModal, {
      handleClose: function handleClose() {
        return _setShowAdvancedOptions(false);
      },
      isOpen: showAdvancedOptions,
      increaseWithInflation: increaseWithInflation,
      calculateFuturePurchasingPower: calculateFuturePurchasingPower,
      workOfflineSection: workOfflineSection,
      inputsData: inputsData
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Composition */.fS, {
      areas: fields,
      gap: 1,
      height: "100%",
      children: function children(Fields) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Fields.CalculatorType, {
            marginBottom: 0.75,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
              name: "useStackingAmount",
              initialValue: inputsData.defaults.calculator === 'predictByInvestment',
              type: "checkbox",
              children: function children(_ref2) {
                var input = _ref2.input;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(TabSwitch, {
                    tabs: [inputsData.defaults.calculator === 'predictByInvestment' ? {
                      value: true,
                      label: inputsData.predictByInvestmentAmount
                    } : {
                      value: false,
                      label: inputsData.predictByGoal
                    }, inputsData.defaults.calculator === 'predictByInvestment' ? {
                      value: false,
                      label: inputsData.predictByGoal
                    } : {
                      value: true,
                      label: inputsData.predictByInvestmentAmount
                    }],
                    onChange: function onChange() {
                      return handleCalculatorTypeChange(input, inputsData);
                    },
                    value: input.checked,
                    primary: true
                  })
                });
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Fields.BitcoinFormat, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
              name: "isSatoshis",
              initialValue: true,
              type: "checkbox",
              format: function format(value) {
                return value ? Number(value).toFixed(isSatoshis ? 0 : 8) : '';
              },
              children: function children(_ref3) {
                var input = _ref3.input,
                    meta = _ref3.meta;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.StyledField, {
                    label: inputsData.isSatoshisLabel,
                    error: meta.touched && meta.error,
                    help: helpTexts.isSatoshis,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TabSwitch, {
                      tabs: [{
                        value: true,
                        label: 'Satoshi'
                      }, {
                        value: false,
                        label: 'Bitcoin'
                      }],
                      value: input.checked,
                      onChange: function onChange(newValue) {
                        (0,convertBtcSats/* onToggle */.Xn)(form, isSatoshis, newValue);
                        input.onChange(newValue);
                      }
                    })
                  })
                });
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Fields.Currency, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
              name: "currency",
              initialValue: (0,utils_currency/* getLocaleCurrency */.cQ)(inputsData.defaults.currency),
              children: function children(_ref4) {
                var input = _ref4.input,
                    meta = _ref4.meta;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.StyledField, {
                  label: inputsData.currenySelectorLabel,
                  error: meta.touched && meta.error,
                  help: helpTexts.currency,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_form.Select, inputs_objectSpread(inputs_objectSpread({}, input), {}, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("option", {
                      value: "USD",
                      children: ["USD (", (0,utils_currency/* getCurrencySymbol */.jK)('USD'), ")"]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("option", {
                      value: "GBP",
                      children: ["GBP (", (0,utils_currency/* getCurrencySymbol */.jK)('GBP'), ")"]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("option", {
                      value: "EUR",
                      children: ["EUR (", (0,utils_currency/* getCurrencySymbol */.jK)('EUR'), ")"]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("option", {
                      value: "JPY",
                      children: ["JPY (", (0,utils_currency/* getCurrencySymbol */.jK)('JPY'), ")"]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("option", {
                      value: "AUD",
                      children: ["AUD (", (0,utils_currency/* getCurrencySymbol */.jK)('AUD'), ")"]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("option", {
                      value: "CAD",
                      children: ["CAD (", (0,utils_currency/* getCurrencySymbol */.jK)('CAD'), ")"]
                    })]
                  }))
                });
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Fields.StackingFrequency, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es.Field, {
              name: "stackingFrequency",
              initialValue: inputsData.defaults.stackingFrequency,
              children: function children(_ref5) {
                var input = _ref5.input,
                    meta = _ref5.meta;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.StyledField, {
                  label: inputsData.stackingFrequencyLabel,
                  error: meta.touched && meta.error,
                  help: helpTexts.stackingFrequency,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(TabSwitch, {
                    tabs: [{
                      value: 'DAILY',
                      label: 'Daily'
                    }, {
                      value: 'WEEKLY',
                      label: 'Weekly'
                    }, {
                      value: 'MONTHLY',
                      label: 'Monthly'
                    }, {
                      value: 'YEARLY',
                      label: 'Yearly'
                    }],
                    onChange: input.onChange,
                    value: input.value
                  })
                });
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Fields.Goal, {
            children: useStackingAmount ? /*#__PURE__*/(0,jsx_runtime.jsx)(stackingAmount, {
              inputsData: inputsData
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(goal/* default */.Z, {
              inputsData: inputsData
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Fields.GoalDate, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(GoalDateField, {
              inputsData: inputsData
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Fields.PricePredictions, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(pricePointsInput, {
              inputsData: inputsData,
              showPricePredictionModal: showPricePredictionModal,
              setShowPricePredictionModal: setShowPricePredictionModal
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Fields.AdvancedModal, {
            marginBottom: 1.5,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(AdvancedOptionsFormButton, {
              setShowAdvancedOptions: function setShowAdvancedOptions() {
                return _setShowAdvancedOptions(true);
              }
            })
          })]
        });
      }
    })]
  });
};

/* harmony default export */ var inputs = (CalculatorInputs);

/***/ }),

/***/ 61952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ predictionInputs; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/atomic-layout/lib/esm/index.js
var esm = __webpack_require__(19010);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./components/atoms/form/index.js + 2 modules
var atoms_form = __webpack_require__(6427);
// EXTERNAL MODULE: ./utils/currency.js
var utils_currency = __webpack_require__(92442);
// EXTERNAL MODULE: ./components/atoms/Buttons.js
var atoms_Buttons = __webpack_require__(87314);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/date.js
var utils_date = __webpack_require__(90144);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 29 modules
var format = __webpack_require__(18813);
;// CONCATENATED MODULE: ./images/iconAdd.svg
/* harmony default export */ var iconAdd = ({"src":"/_next/static/media/iconAdd.a3280d6b.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./images/iconRemove.svg
/* harmony default export */ var iconRemove = ({"src":"/_next/static/media/iconRemove.1ad76f55.svg","height":28,"width":28});
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(42997);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/content/calculator/inputs/pricePoint.js


var _templateObject;















var pricePointAreas = "\n    dateInput priceInput buttons\n";
var PriceInputContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 1rem;\n"])));
var PricePoint = function PricePoint(_ref) {
  var idx = _ref.idx,
      date = _ref.date,
      value = _ref.value,
      disableDate = _ref.disableDate,
      disableValue = _ref.disableValue,
      _onChange = _ref.onChange,
      _ref$renderAddButton = _ref.renderAddButton,
      renderAddButton = _ref$renderAddButton === void 0 ? true : _ref$renderAddButton,
      _ref$renderRemoveButt = _ref.renderRemoveButton,
      renderRemoveButton = _ref$renderRemoveButt === void 0 ? true : _ref$renderRemoveButt,
      onAdd = _ref.onAdd,
      onRemove = _ref.onRemove,
      goalDate = _ref.goalDate,
      currency = _ref.currency,
      dateLabel = _ref.dateLabel,
      valueLabel = _ref.valueLabel;
  var gap = '1rem';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Composition */.fS, {
    areas: pricePointAreas,
    templateCols: "minmax(33%, 1fr) minmax(10rem, 12rem) 60px",
    gap: 1,
    children: function children(_ref2) {
      var DateInput = _ref2.DateInput,
          PriceInput = _ref2.PriceInput,
          Buttons = _ref2.Buttons;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DateInput, {
          flex: true,
          style: {
            minWidth: '130px',
            flexDirection: 'column',
            gap: gap
          },
          children: [dateLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: dateLabel
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_form.DatePicker, {
            id: "priceinput-".concat(idx),
            disabled: disableDate,
            value: (0,format/* default */.Z)(date, 'yyyy-MM-dd', new Date()),
            onChange: function onChange(newDate) {
              return _onChange({
                date: newDate,
                value: value
              });
            },
            minDate: (0,utils_date/* dateOnly */.hp)(new Date())
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PriceInput, {
          flex: true,
          style: {
            flexDirection: 'column',
            gap: gap
          },
          children: [valueLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: valueLabel
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PriceInputContainer, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(utils_currency/* CurrencyInput */.LH, {
              currency: currency,
              value: value,
              onChange: function onChange(e) {
                return _onChange({
                  date: date,
                  value: e.target.value
                });
              },
              disabled: disableValue,
              min: 0,
              $error: value < 0
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons, {
              align: "center",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                flex: true,
                gap: "0.7rem",
                flexDirection: "row",
                justifyContent: "space-between",
                children: [renderAddButton && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Buttons/* FormIconButton */.x9, {
                  type: "button",
                  onClick: function onClick() {
                    return onAdd();
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: iconAdd,
                    alt: "add",
                    height: "15px",
                    width: "15px"
                  })
                }), renderRemoveButton && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Buttons/* FormIconButton */.x9, {
                  type: "button",
                  onClick: function onClick() {
                    return onRemove();
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: iconRemove,
                    alt: "remove",
                    height: "15px",
                    width: "15px"
                  })
                })]
              })
            })]
          })]
        })]
      });
    }
  });
};
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js + 1 modules
var differenceInDays = __webpack_require__(29383);
// EXTERNAL MODULE: ./utils/useCryptoValue.js
var useCryptoValue = __webpack_require__(19319);
;// CONCATENATED MODULE: ./components/content/calculator/inputs/predictionInputs.js










var sortByDate = function sortByDate(arr) {
  return arr.sort(function (a, b) {
    return a.date > b.date ? 1 : -1;
  });
};

var PredictionInputs = function PredictionInputs(_ref) {
  var inputsData = _ref.inputsData;
  var form = (0,react_final_form_es.useForm)();

  var _useFormState = (0,react_final_form_es.useFormState)(),
      _useFormState$values = _useFormState.values,
      goalDate = _useFormState$values.goalDate,
      currency = _useFormState$values.currency,
      _useFormState$values$ = _useFormState$values.pricePredictions,
      pricePredictions = _useFormState$values$ === void 0 ? [] : _useFormState$values$;

  var _useCryptoValue = (0,useCryptoValue/* default */.Z)(),
      btcPrices = _useCryptoValue.data,
      isValidating = _useCryptoValue.isValidating;

  var btcPriceInCurrency = btcPrices[currency];

  var _useState = (0,react.useState)(true),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  (0,react.useEffect)(function () {
    if (!isValidating) {
      setIsLoading(false);
    }
  }, [isValidating]); // TODO: Make a simple spinner.

  if (isLoading) return 'loading...';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Box */.xu, {
    flex: true,
    flexDirection: "column",
    gap: 1,
    flexGrow: 1,
    children: pricePredictions.map(function (_ref2, idx) {
      var date = _ref2.date,
          value = _ref2.value;
      var isFirst = idx === 0;

      if (isFirst && value === undefined) {
        value = btcPriceInCurrency;
      }

      var isLast = idx >= pricePredictions.length - 1;
      var isDateAdjacent = !isLast && (0,differenceInDays/* default */.Z)(pricePredictions[idx + 1].date, date) <= 1;
      var showAddButton = isFirst || !isDateAdjacent;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PricePoint, {
        dateLabel: isFirst && inputsData.futurePriceDateInputLabel,
        valueLabel: isFirst && inputsData.futurePricePriceInputLabel,
        idx: idx,
        inputsData: inputsData,
        date: date,
        goalDate: goalDate,
        currency: currency,
        value: value,
        disableDate: isFirst,
        disableValue: isFirst,
        renderAddButton: showAddButton,
        renderRemoveButton: !isFirst,
        onChange: function onChange(newVal) {
          form.change('pricePredictions', sortByDate([].concat((0,toConsumableArray/* default */.Z)(pricePredictions.slice(0, idx)), [newVal], (0,toConsumableArray/* default */.Z)(pricePredictions.slice(idx + 1)))));
        },
        onAdd: function onAdd() {
          form.change('pricePredictions', [].concat((0,toConsumableArray/* default */.Z)(pricePredictions.slice(0, idx + 1)), [{
            date: (0,addDays/* default */.Z)(date, 1),
            value: ''
          }], (0,toConsumableArray/* default */.Z)(pricePredictions.slice(idx + 1))));
        },
        onRemove: function onRemove() {
          form.change('pricePredictions', [].concat((0,toConsumableArray/* default */.Z)(pricePredictions.slice(0, idx)), (0,toConsumableArray/* default */.Z)(pricePredictions.slice(idx + 1))));
        }
      }, idx);
    })
  });
};

/* harmony default export */ var predictionInputs = (PredictionInputs);

/***/ }),

/***/ 90144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hp": function() { return /* binding */ dateOnly; },
/* harmony export */   "mA": function() { return /* binding */ getOppositeDate; },
/* harmony export */   "ms": function() { return /* binding */ isBeforeBitcoinExistence; },
/* harmony export */   "p$": function() { return /* binding */ formatDateForHistoricApi; },
/* harmony export */   "qw": function() { return /* binding */ getYMD; }
/* harmony export */ });
/* unused harmony exports durationToString, mirrorDate, getDateFromString */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16835);
/* harmony import */ var duration_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38174);
/* harmony import */ var duration_fns__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(duration_fns__WEBPACK_IMPORTED_MODULE_0__);




var dateOnly = function dateOnly(dateObj) {
  return new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), 0, 0, 0, 0);
};
var durationToString = function durationToString(goalDateSelect) {
  var parsedDuration = duration.parse(goalDateSelect);

  if (parsedDuration.years) {
    return "Last ".concat(parsedDuration.years, " year").concat(parsedDuration.years > 1 ? 's' : '');
  }

  if (parsedDuration.months) {
    return "Last ".concat(parsedDuration.months, " month").concat(parsedDuration.months > 1 ? 's' : '');
  }

  if (parsedDuration.weeks) {
    return "Last ".concat(parsedDuration.weeks, " week").concat(parsedDuration.weeks > 1 ? 's' : '');
  }

  return '';
}; // input: a, b => output: a - | a - b |

var mirrorDate = function mirrorDate(dateLeft, dateRight) {
  var diffInMinutes = differenceInMinutes(dateRight, dateLeft);
  return subMinutes(dateLeft, diffInMinutes);
};
function getYMD(date) {
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate()
  };
}
function getOppositeDate(durationISO) {
  var period = duration_fns__WEBPACK_IMPORTED_MODULE_0__.parse(durationISO);
  var oppositePeriod = {};

  for (var _i = 0, _Object$entries = Object.entries(period); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    oppositePeriod[key] = -value;
  }

  return duration_fns__WEBPACK_IMPORTED_MODULE_0__.apply(new Date(), oppositePeriod);
}
function isBeforeBitcoinExistence(_ref) {
  var year = _ref.year,
      month = _ref.month,
      day = _ref.day;
  if (year < 2010) return true;

  if (year == 2010 && month < 7) {
    return true;
  }

  if (year == 2010 && month == 7 && day < 17) return true;
  return false;
}
function formatDateForHistoricApi(dateObject) {
  var year = dateObject.year,
      month = dateObject.month,
      day = dateObject.day; // Pad month and day with leading zero if they are less than 10

  var paddedMonth = month < 10 ? "0".concat(month) : "".concat(month);
  var paddedDay = day < 10 ? "0".concat(day) : "".concat(day);
  return "".concat(year, "-").concat(paddedMonth, "-").concat(paddedDay);
}
function getDateFromString(dateString) {
  var date = new Date(dateString);
  var year = date.getFullYear(); // JavaScript's getMonth() function returns a 0-based month, so we add 1 to get a 1-based month

  var month = date.getMonth() + 1;
  var day = date.getDate();
  return {
    year: year,
    month: month,
    day: day
  };
}

/***/ }),

/***/ 19319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCryptoValue; },
/* harmony export */   "a": function() { return /* binding */ useRawCryptoValue; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36864);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function useRawCryptoValue(_ref) {
  var swrOptions = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _ref);

  var _useSWR = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)('/api/satsgoal-current', _objectSpread(_objectSpread({}, swrOptions), {}, {
    errorRetryCount: 10,
    errorRetryInterval: 200,
    refreshInterval: 300000,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  })),
      data = _useSWR.data,
      error = _useSWR.error,
      isValidating = _useSWR.isValidating;

  return {
    data: data,
    error: error,
    isValidating: isValidating
  };
}
function useCryptoValue() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var swrOptions = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _ref2);

  var _useRawCryptoValue = useRawCryptoValue(_objectSpread({}, swrOptions)),
      data = _useRawCryptoValue.data,
      error = _useRawCryptoValue.error,
      isValidating = _useRawCryptoValue.isValidating;

  return {
    data: data,
    error: error,
    isValidating: isValidating
  };
}

/***/ }),

/***/ 11617:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 74764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = exports.B6 = __webpack_unused_export__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var inBrowser = typeof navigator !== "undefined";

// these browsers don't fully support navigator.onLine, so we need to use a polling backup
var unsupportedUserAgentsPattern = /Windows.*Chrome|Windows.*Firefox|Linux.*Chrome/;

var ping = function ping(_ref) {
  var url = _ref.url,
      timeout = _ref.timeout;

  return new Promise(function (resolve) {
    var isOnline = function isOnline() {
      return resolve(true);
    };
    var isOffline = function isOffline() {
      return resolve(false);
    };

    var xhr = new XMLHttpRequest();

    xhr.onerror = isOffline;
    xhr.ontimeout = isOffline;
    xhr.onreadystatechange = function () {
      if (xhr.readyState === xhr.HEADERS_RECEIVED) {
        if (xhr.status) {
          isOnline();
        } else {
          isOffline();
        }
      }
    };

    xhr.open("GET", url);
    xhr.timeout = timeout;
    xhr.send();
  });
};

var propTypes = {
  children: _propTypes2.default.node,
  onChange: _propTypes2.default.func,
  polling: _propTypes2.default.oneOfType([_propTypes2.default.shape({
    url: _propTypes2.default.string,
    interval: _propTypes2.default.number,
    timeout: _propTypes2.default.number
  }), _propTypes2.default.bool]),
  wrapperType: _propTypes2.default.string
};

var defaultProps = {
  polling: true,
  wrapperType: "span"
};

var defaultPollingConfig = {
  enabled: inBrowser && unsupportedUserAgentsPattern.test(navigator.userAgent),
  url: "https://httpbin.org/get",
  timeout: 5000,
  interval: 5000
};

// base class that detects offline/online changes

var Base = function (_Component) {
  _inherits(Base, _Component);

  function Base() {
    _classCallCheck(this, Base);

    var _this = _possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).call(this));

    _this.state = {
      online: inBrowser && typeof navigator.onLine === "boolean" ? navigator.onLine : true
    };
    // bind event handlers
    _this.goOnline = _this.goOnline.bind(_this);
    _this.goOffline = _this.goOffline.bind(_this);
    return _this;
  }

  _createClass(Base, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("online", this.goOnline);
      window.addEventListener("offline", this.goOffline);

      if (this.getPollingConfig().enabled) {
        this.startPolling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("online", this.goOnline);
      window.removeEventListener("offline", this.goOffline);

      if (this.pollingId) {
        this.stopPolling();
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _props = this.props,
          children = _props.children,
          wrapperType = _props.wrapperType;

      // usual case: one child that is a react Element

      if ((0, _react.isValidElement)(children)) {
        return children;
      }

      // no children
      if (!children) {
        return null;
      }

      // string children, multiple children, or something else
      return _react.createElement.apply(undefined, [wrapperType, {}].concat(_toConsumableArray(_react.Children.toArray(children))));
    }
  }, {
    key: "getPollingConfig",
    value: function getPollingConfig() {
      switch (this.props.polling) {
        case true:
          return defaultPollingConfig;
        case false:
          return { enabled: false };
        default:
          return Object.assign({}, defaultPollingConfig, this.props.polling);
      }
    }
  }, {
    key: "goOnline",
    value: function goOnline() {
      if (!this.state.online) {
        this.callOnChangeHandler(true);
        this.setState({ online: true });
      }
    }
  }, {
    key: "goOffline",
    value: function goOffline() {
      if (this.state.online) {
        this.callOnChangeHandler(false);
        this.setState({ online: false });
      }
    }
  }, {
    key: "callOnChangeHandler",
    value: function callOnChangeHandler(online) {
      if (this.props.onChange) {
        this.props.onChange(online);
      }
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      var _this2 = this;

      var _getPollingConfig = this.getPollingConfig(),
          interval = _getPollingConfig.interval;

      this.pollingId = setInterval(function () {
        var _getPollingConfig2 = _this2.getPollingConfig(),
            url = _getPollingConfig2.url,
            timeout = _getPollingConfig2.timeout;

        ping({ url: url, timeout: timeout }).then(function (online) {
          online ? _this2.goOnline() : _this2.goOffline();
        });
      }, interval);
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      clearInterval(this.pollingId);
    }
  }]);

  return Base;
}(_react.Component);

Base.propTypes = propTypes;
Base.defaultProps = defaultProps;

var Online = __webpack_unused_export__ = function (_Base) {
  _inherits(Online, _Base);

  function Online() {
    _classCallCheck(this, Online);

    return _possibleConstructorReturn(this, (Online.__proto__ || Object.getPrototypeOf(Online)).apply(this, arguments));
  }

  _createClass(Online, [{
    key: "render",
    value: function render() {
      return this.state.online ? this.renderChildren() : null;
    }
  }]);

  return Online;
}(Base);

Online.propTypes = propTypes;
Online.defaultProps = defaultProps;

var Offline = exports.B6 = function (_Base2) {
  _inherits(Offline, _Base2);

  function Offline() {
    _classCallCheck(this, Offline);

    return _possibleConstructorReturn(this, (Offline.__proto__ || Object.getPrototypeOf(Offline)).apply(this, arguments));
  }

  _createClass(Offline, [{
    key: "render",
    value: function render() {
      return !this.state.online ? this.renderChildren() : null;
    }
  }]);

  return Offline;
}(Base);

Offline.propTypes = propTypes;
Offline.defaultProps = defaultProps;

var Detector = __webpack_unused_export__ = function (_Base3) {
  _inherits(Detector, _Base3);

  function Detector() {
    _classCallCheck(this, Detector);

    return _possibleConstructorReturn(this, (Detector.__proto__ || Object.getPrototypeOf(Detector)).apply(this, arguments));
  }

  _createClass(Detector, [{
    key: "render",
    value: function render() {
      return this.props.render({ online: this.state.online });
    }
  }]);

  return Detector;
}(Base);

Detector.propTypes = Object.assign({}, propTypes, {
  render: _propTypes2.default.func.isRequired
});
Detector.defaultProps = defaultProps;


/***/ }),

/***/ 25224:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = function () {
  return _react2.default.createElement(
    'svg',
    { width: '14', height: '11', viewBox: '0 0 14 11' },
    _react2.default.createElement('path', { d: 'M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0', fill: '#fff', fillRule: 'evenodd' })
  );
};

/***/ }),

/***/ 80888:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(94184);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _check = __webpack_require__(25224);

var _check2 = _interopRequireDefault(_check);

var _x = __webpack_require__(56963);

var _x2 = _interopRequireDefault(_x);

var _util = __webpack_require__(11520);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toggle = function (_PureComponent) {
  _inherits(Toggle, _PureComponent);

  function Toggle(props) {
    _classCallCheck(this, Toggle);

    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.previouslyChecked = !!(props.checked || props.defaultChecked);
    _this.state = {
      checked: !!(props.checked || props.defaultChecked),
      hasFocus: false
    };
    return _this;
  }

  _createClass(Toggle, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.checked !== this.props.checked) {
        // Disable linting rule here since this usage of setState inside
        // componentDidUpdate is OK; see
        // https://reactjs.org/docs/react-component.html#componentdidupdate
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ checked: !!this.props.checked });
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      if (this.props.disabled) {
        return;
      }
      var checkbox = this.input;
      if (event.target !== checkbox && !this.moved) {
        this.previouslyChecked = checkbox.checked;
        event.preventDefault();
        checkbox.focus();
        checkbox.click();
        return;
      }

      var checked = this.props.hasOwnProperty('checked') ? this.props.checked : checkbox.checked;

      this.setState({ checked: checked });
    }
  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      if (this.props.disabled) {
        return;
      }
      this.startX = (0, _util.pointerCoord)(event).x;
      this.activated = true;
    }
  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(event) {
      if (!this.activated) return;
      this.moved = true;

      if (this.startX) {
        var currentX = (0, _util.pointerCoord)(event).x;
        if (this.state.checked && currentX + 15 < this.startX) {
          this.setState({ checked: false });
          this.startX = currentX;
          this.activated = true;
        } else if (currentX - 15 > this.startX) {
          this.setState({ checked: true });
          this.startX = currentX;
          this.activated = currentX < this.startX + 5;
        }
      }
    }
  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd(event) {
      if (!this.moved) return;
      var checkbox = this.input;
      event.preventDefault();

      if (this.startX) {
        var endX = (0, _util.pointerCoord)(event).x;
        if (this.previouslyChecked === true && this.startX + 4 > endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({ checked: false });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        } else if (this.startX - 4 < endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({ checked: true });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        }

        this.activated = false;
        this.startX = null;
        this.moved = false;
      }
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(event) {
      var onFocus = this.props.onFocus;


      if (onFocus) {
        onFocus(event);
      }

      this.setState({ hasFocus: true });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      var onBlur = this.props.onBlur;


      if (onBlur) {
        onBlur(event);
      }

      this.setState({ hasFocus: false });
    }
  }, {
    key: 'getIcon',
    value: function getIcon(type) {
      var icons = this.props.icons;

      if (!icons) {
        return null;
      }
      return icons[type] === undefined ? Toggle.defaultProps.icons[type] : icons[type];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          _icons = _props.icons,
          inputProps = _objectWithoutProperties(_props, ['className', 'icons']);

      var classes = (0, _classnames2.default)('react-toggle', {
        'react-toggle--checked': this.state.checked,
        'react-toggle--focus': this.state.hasFocus,
        'react-toggle--disabled': this.props.disabled
      }, className);

      return _react2.default.createElement(
        'div',
        { className: classes,
          onClick: this.handleClick,
          onTouchStart: this.handleTouchStart,
          onTouchMove: this.handleTouchMove,
          onTouchEnd: this.handleTouchEnd },
        _react2.default.createElement(
          'div',
          { className: 'react-toggle-track' },
          _react2.default.createElement(
            'div',
            { className: 'react-toggle-track-check' },
            this.getIcon('checked')
          ),
          _react2.default.createElement(
            'div',
            { className: 'react-toggle-track-x' },
            this.getIcon('unchecked')
          )
        ),
        _react2.default.createElement('div', { className: 'react-toggle-thumb' }),
        _react2.default.createElement('input', _extends({}, inputProps, {
          ref: function ref(_ref) {
            _this2.input = _ref;
          },
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          className: 'react-toggle-screenreader-only',
          type: 'checkbox' }))
      );
    }
  }]);

  return Toggle;
}(_react.PureComponent);

exports.Z = Toggle;


Toggle.displayName = 'Toggle';

Toggle.defaultProps = {
  icons: {
    checked: _react2.default.createElement(_check2.default, null),
    unchecked: _react2.default.createElement(_x2.default, null)
  }
};

Toggle.propTypes = {
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  defaultChecked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  className: _propTypes2.default.string,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  id: _propTypes2.default.string,
  'aria-labelledby': _propTypes2.default.string,
  'aria-label': _propTypes2.default.string,
  icons: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    checked: _propTypes2.default.node,
    unchecked: _propTypes2.default.node
  })])
};

/***/ }),

/***/ 11520:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.pointerCoord = pointerCoord;
// Copyright 2015-present Drifty Co.
// http://drifty.com/
// from: https://github.com/driftyco/ionic/blob/master/src/util/dom.ts

function pointerCoord(event) {
  // get coordinates for either a mouse click
  // or a touch depending on the given event
  if (event) {
    var changedTouches = event.changedTouches;
    if (changedTouches && changedTouches.length > 0) {
      var touch = changedTouches[0];
      return { x: touch.clientX, y: touch.clientY };
    }
    var pageX = event.pageX;
    if (pageX !== undefined) {
      return { x: pageX, y: event.pageY };
    }
  }
  return { x: 0, y: 0 };
}

/***/ }),

/***/ 56963:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = function () {
  return _react2.default.createElement(
    'svg',
    { width: '10', height: '10', viewBox: '0 0 10 10' },
    _react2.default.createElement('path', { d: 'M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12', fill: '#fff', fillRule: 'evenodd' })
  );
};

/***/ })

}]);